import { createStore } from 'jotai';

let appStore = createStore();

/**
 * The store behind the app's Jotai `<Provider>`. Also the way to read or write
 * atoms from outside React (axios interceptors, services, plain functions).
 */
export const getAppStore = () => appStore;

/**
 * Swaps in a fresh store so every atom is back at its default value. Tests call
 * this once per render, which keeps state from leaking between them while code
 * that reads through `getAppStore()` sees the same store the tree rendered with.
 */
export const resetAppStore = () => {
  appStore = createStore();
  return appStore;
};
